export default {
	namespaced: true,
	state: {
		item: {
			files: [],
			outputHtml: '',
		},
	},
}